import type { TipoSolicitacao } from './solicitacao.types';

/**
 * Motivo da Solicitação — lista por tipo + detalhe (obrigatório só em "Outro"). Só os tipos
 * abaixo pedem motivo; os demais (Admissão, Desligamento etc.) já carregam o motivo no
 * próprio tipo. Solicitações antigas não têm motivo — nunca é exigido retroativamente.
 *
 * Listas iniciais sugeridas — ajustar aqui conforme o SI revisar. O valor gravado é o
 * próprio texto da opção (não um código), então trocar o texto de uma opção não quebra as
 * antigas, só deixa de oferecê-la.
 */
export const MOTIVO_OUTRO = 'Outro';

export const MOTIVOS_POR_TIPO_SOLICITACAO: Partial<Record<TipoSolicitacao, readonly string[]>> = {
  troca_equipamento: [
    'Defeito ou mau funcionamento',
    'Equipamento danificado (queda, líquido etc.)',
    'Desempenho insuficiente para o projeto',
    'Exigência do cliente / homologação',
    MOTIVO_OUTRO,
  ],
  devolucao: [
    'Fim do projeto / alocação',
    'Equipamento sem uso',
    'Troca por outro equipamento',
    'Defeito ou mau funcionamento',
    MOTIVO_OUTRO,
  ],
  pedido_colaborador: [
    'Não possui o item',
    'Item com defeito',
    'Item perdido ou extraviado',
    'Necessidade do projeto',
    MOTIVO_OUTRO,
  ],
};

export function tipoSolicitacaoExigeMotivo(tipo: TipoSolicitacao | '' | null | undefined): boolean {
  return Boolean(tipo && MOTIVOS_POR_TIPO_SOLICITACAO[tipo]);
}

/** null = ok; string = o que falta (mesma regra usada no schema e no formulário). */
export function validarMotivoSolicitacao(
  tipo: TipoSolicitacao,
  motivo: string | null | undefined,
  detalhe: string | null | undefined
): string | null {
  if (!tipoSolicitacaoExigeMotivo(tipo)) return null;
  if (!motivo?.trim()) return 'Motivo';
  if (motivo === MOTIVO_OUTRO && !detalhe?.trim()) return 'Detalhe do motivo';
  return null;
}

/** "Defeito ou mau funcionamento — tela piscando" / "Outro — ..." / só o motivo. */
export function motivoSolicitacaoLegivel(motivo: string | null | undefined, detalhe: string | null | undefined): string {
  return [motivo?.trim(), detalhe?.trim()].filter(Boolean).join(' — ');
}
